var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notification"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/notification"
  }, /*#__PURE__*/React.createElement("g", {
    id: "notification_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.8052 2.91016C9.49518 2.91016 6.80518 5.60016 6.80518 8.91016V11.8002C6.80518 12.4102 6.54518 13.3402 6.23518 13.8602L5.08518 15.7702C4.37518 16.9502 4.86518 18.2602 6.16518 18.7002C10.4752 20.1402 15.1252 20.1402 19.4352 18.7002C20.6452 18.3002 21.1752 16.8702 20.5152 15.7702L19.3652 13.8602C19.0652 13.3402 18.8052 12.4102 18.8052 11.8002V8.91016C18.8052 5.61016 16.1052 2.91016 12.8052 2.91016Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.6551 3.19994C14.3451 3.10994 14.0251 3.03994 13.6951 2.99994C12.7351 2.87994 11.8151 2.94994 10.9551 3.19994C11.2451 2.45994 11.9651 1.93994 12.8051 1.93994C13.6451 1.93994 14.3651 2.45994 14.6551 3.19994Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.8052 19.0601C15.8052 20.7101 14.4552 22.0601 12.8052 22.0601C11.9852 22.0601 11.2252 21.7201 10.6852 21.1801C10.1452 20.6401 9.80518 19.8801 9.80518 19.0601",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.73c5eabb17dcb2337c8aa5139237d0b0.svg";
export { ForwardRef as ReactComponent };